module.exports = __webpack_public_path__ + "img/about2.887fb31.jpg";